<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { Background } from "./Background.js";
	import { type UlProps, UlSize } from "./UlProps.js";

	const {
		items,
		size = UlSize.Small,
		background = Background.Light,
		largeTitle = false,
	}: {
		items: UlProps[];
		size?: UlSize;
		background?: Background;
		largeTitle?: boolean;
	} = $props();

	const onlyTitle = items.every(
		(item) =>
			(item.desc === "" || item.desc === undefined) && (item.descItems === undefined || item.descItems.length === 0),
	);
</script>

{#each items as { title, desc, descItems } (title)}
	<div class={["flex flex-col", onlyTitle ? "items-center" : "items-start"]}>
		<div class="pt-1">
			{#if title}
				<h3
					class={[
						"tracking-[0.01em] mb-2",
						largeTitle ? "text-2md lg:text-lg font-bold" : "text-2md",
						background === Background.Onyx ? "text-white" : "text-fstonyx",
					]}
				>
					<Formatted text={title} />
				</h3>
			{/if}

			{#if desc}
				<p
					class={[
						"mb-0 max-w-[30.625rem] text-fstgrey-600",
						size === UlSize.Small && "text-sm",
						size === UlSize.Medium && "text-base",
						size === UlSize.Large && background !== Background.Onyx && "text-lg font-loos-wide text-fstonyx",
					]}
				>
					<Formatted text={desc} />
				</p>
			{/if}

			{#if descItems?.length}
				<ul
					class={[
						"custom-list max-w-[30.625rem] text-fstgrey-600",
						desc ? "mt-3" : "mt-0",
						size === UlSize.Small && "text-sm",
						size === UlSize.Medium && "text-base",
						size === UlSize.Large && background !== Background.Onyx && "text-lg font-loos-wide text-fstonyx",
					]}
				>
					{#each descItems as descItem (descItem)}
						<li>
							<Formatted text={descItem} />
						</li>
					{/each}
				</ul>
			{/if}
		</div>
	</div>
{/each}
